import { ICruiseSearchApiObject, ICruiseSearchFilterParams } from '../interfaces/ISearchApi';

export const defaultSearchParams: ICruiseSearchApiObject = {
    limit: 10,
    offset: 0,
    sortString: 'relevance',
    filterParams: {} as ICruiseSearchFilterParams,
};
